import { render, staticRenderFns } from "./guest-a.vue?vue&type=template&id=2e98aac8&scoped=true&"
import script from "./guest-a.vue?vue&type=script&lang=js&"
export * from "./guest-a.vue?vue&type=script&lang=js&"
import style0 from "./guest-a.vue?vue&type=style&index=0&id=2e98aac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98aac8",
  null
  
)

export default component.exports